module.exports = __webpack_public_path__ + "static/media/vinglabs_revenue_color_transparent.93f11916.png";